import { render, staticRenderFns } from "./WebVideoForm.vue?vue&type=template&id=f1f2d5f8&"
import script from "./WebVideoForm.vue?vue&type=script&lang=ts&"
export * from "./WebVideoForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports